<p>multi-station-pre-registration works!</p>
